export default __webpack_public_path__ + "static/media/externalLink.57f69569.svg";